/*
 * Copyright (c) 2026.
 * # Autor: TECINCO TECNOLOGIA
 * # Dev: Alejandro Meriño Rodrìguez
 * # Versión: 2.0.0
 */

/**
 * Schema da tool para adição de peças a Ordem de Serviço ou Orçamento
 * Este schema é usado pelo LLM para entender como chamar a ferramenta
 */
export const tools_add_parts_os_budget = [
    {
        type: "function",
        function: {
            name: "addPartsToOsOrBudget",
            description: "Add parts to a budget or service order. Use this tool when the user requests to add one or more parts to an OS or budget.",
            parameters: {
                type: "object",
                properties: {
                    os_budget :{
                        type: "object",
                        description: "Object containing identification details for the OS or Budget. DO NOT stringify this object.",
                        properties :{
                            isBudget: {
                                type: "boolean",
                                default: false,
                                description: "True if user mentions 'budget' (orçamento). Otherwise false. Priority: use o context",
                            },
                            id: {
                                type: ["string", "null"],
                                description: "Database unique ID (hexadecimal)."
                            },
                            code:{
                                type: ["string", "null"],
                                description: "Human-readable numeric code."

                            },
                            name_customer: {
                                type: ["string", "null"],
                                description: "Customer name for lookup"
                            },
                            plate: {
                                type: ["string", "null"],
                                minLength: 7,
                                maxLength: 7,
                                pattern: "^[A-Z]{3}[0-9]{4}$|^[A-Z]{3}[0-9][A-Z][0-9]{2}$",
                                description: "Vehicle plate."
                            }
                        },
                        required: ["isBudget"],
                        anyOf: [
                            { required: ["id"] },
                            { required: ["code"] },
                            { required: ["name_customer"] },
                            { required: ["plate"] }
                        ],
                        additionalProperties: false
                    },
                    parts: {
                        type: "array",
                        description: "List of parts to add.",
                        items: {
                            type: "object",
                            properties: {
                                code: { type: ["string", "null"] },
                                search_by_description: { type: ["string", "null"] },
                                quantity: {
                                    type: "number",
                                    default: 1,
                                    minimum: 1
                                }
                            },
                            anyOf: [
                                { required: ["code"] },
                                { required: ["search_by_description"] }
                            ]
                        },
                        minItems: 1
                    },
                    dry_run: {
                        type: "boolean",
                        default: false,
                        description: "If true, only simulate the addition without actually adding parts. Use for validation/preview."
                    }
                },
                required: ["os_budget", "parts"],
                additionalProperties: false
            },
        },
    }
];
